import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const ClientAdminRoute: React.FC = () => {
  const { user } = useUser();

  if (!user) {
    // No user data, redirect to login
    return <Navigate to="/login" replace />;
  }
  const role = (user.Role || user.role || '').toLowerCase();
  const isClientAdmin = role === 'client admin';

  if (!isClientAdmin) {
    // User is not a Client Admin, redirect to client patients
    return <Navigate to="/client/patients" replace />;
  }

  // User is authenticated and is a Client Admin, allow access
  return <Outlet />;
};

export default ClientAdminRoute;
